import styled from "styled-components";

const SCButton = styled.div`
  padding: 10px 17px;
  border-radius: 25px;
  font-size: 1rem;
  background: #075f6d;
  letter-spacing: 0.3em;
  text-indent: 0.3em;
  cursor: pointer;

  :hover {
    background: #08c9e8;
  }
`;

export {
  SCButton
};
